import _ from 'underscore'
import React from 'react'

import Device from 'pages/Device/index'
import DeviceTabHeader from 'pages/shared/DeviceTabs/DeviceTabHeader'
import HehmDevice from 'pages/HehmDevice'
import Tabs, { Tab } from 'components/Tabs'

import { useFeaturesContext } from 'hooks/FeaturesContext'

import { DeviceBase } from 'types/Device'

type Props = {
  customerName?: string
  devices: Array<DeviceBase>
  activeDeviceId: string
  onActiveDeviceChangeCallback: (deviceId: string) => void
  refreshPageCallback?: () => void
  className?: string
  customerId?: string
  renderMode?: 'all' | 'headersOnly' | 'contentOnly'
}

const DeviceTabs = ({ customerName, activeDeviceId, devices, onActiveDeviceChangeCallback, refreshPageCallback, className, customerId, renderMode = 'all' }: Props) => {
  const activeDevice = devices.find(r => r.deviceId === activeDeviceId)
  const activeDeviceIndex = activeDevice ? devices.indexOf(activeDevice) : 0

  const { enabledFeatures, isEnabledFeaturesLoaded } = useFeaturesContext()

  const hasAlerts = (device) => {
    return device.majorAlertCount || device.minorAlertCount || device.criticalAlertCount || device.sdaMajorAlertCount || device.sdaMinorAlertCount
  }

  if (!isEnabledFeaturesLoaded) {
    return null
  }

  const getDeviceDetails = (device) => {
    if (enabledFeatures.includes('hehm') && device && device.deviceType.toLowerCase() === 'hehm') {
      return (
        <HehmDevice
          refreshPageCallback={refreshPageCallback}
          deviceId={device.deviceId}
          dealerId={device.dealerId}
        />
      )
    } else {
      return (
        <Device
          deviceId={device.deviceId}
          dealerId={device.dealerId}
          isActive={device.deviceId === activeDeviceId}
          refreshPageCallback={refreshPageCallback}
          customerId={customerId}
        />
      )
    }
  }

  let deviceList = devices
  if (!enabledFeatures.includes('hehm')) {
    deviceList = devices.filter(r => r.deviceType.toLowerCase() !== 'hehm')
  }

  const tabItems = _.map(deviceList, r => {
    const item: Tab = {
      key: r.deviceId,
      alerts: hasAlerts(r),
      header: <DeviceTabHeader
                customerName={customerName}
                device={r}
                isActive={r.deviceId === activeDeviceId}
              />,
      details: renderMode !== 'headersOnly' ? getDeviceDetails(r) : null
    }
    return item
  })

  return (
    <div className={className}>
      <Tabs
        tabpage={'device'}
        activeTabIndex={activeDeviceIndex}
        onSelectTabIndexCallback={(index) => onActiveDeviceChangeCallback(deviceList[index].deviceId)}
        tabItems={tabItems}
        renderMode={renderMode}
      />
    </div>
  )
}

export default DeviceTabs
